import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../context/AuthContext";
import useApiV2, {
  CINCO_MINUTOS,
  repetirSoErroDeServidor,
} from "../utils/useApiV2";

export default function useEventTimeseries({
  eventId,
  period,
  baseline = null,
  janela = null,
  group = false,
  enabled = true,
}) {
  const { getEventTimeseries } = useApiV2();
  const { user } = useAuth();
  const branchId = user?.active_branch_id ?? null;

  return useQuery({
    queryKey: [
      "eventTimeseries",
      user?.user_id ?? null,
      branchId,
      eventId,
      period,
      baseline,
      janela,
      group,
    ],
    queryFn: () =>
      getEventTimeseries(eventId, {
        period,
        group,
        incluir_baseline: true,
        ...(baseline ? { baseline } : {}),
        ...(janela ? { janela } : {}),
      }),
    enabled: enabled && !!branchId && !!eventId,
    staleTime: CINCO_MINUTOS,
    retry: repetirSoErroDeServidor,
  });
}
